module.exports = __webpack_public_path__ + "static/logo-fashonista@2x-3fefb5d91f1f54c60bb499f8aacb1dac.png";